import { render, staticRenderFns } from "./RegisterFormPad.vue?vue&type=template&id=934012ce&scoped=true"
import script from "./RegisterFormPad.vue?vue&type=script&lang=js"
export * from "./RegisterFormPad.vue?vue&type=script&lang=js"
import style0 from "./RegisterFormPad.vue?vue&type=style&index=0&id=934012ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934012ce",
  null
  
)

export default component.exports